<div class="flex h-full items-center justify-center">
    @if (isSuccess()) {
        <mat-icon class="text-green-600">check_circle</mat-icon>
    }
    @if (isPending()) {
        <mat-icon class="text-gray-400">schedule</mat-icon>
    }
    @if (isFailure()) {
        <mat-icon class="text-red-600">cancel</mat-icon>
    }
</div>
